export const REMOVE_AREA_ENTRY_STRATEGY = 'REMOVE_AREA_ENTRY_STRATEGY';
export const REMOVE_AREA_ENTRY_STRATEGY_SUCCESSFUL = 'REMOVE_AREA_ENTRY_STRATEGY_SUCCESSFUL';
export const REMOVE_AREA_ENTRY_STRATEGY_FAILED = 'REMOVE_AREA_ENTRY_STRATEGY_FAILED';
